export const MAX_REPORT_SIZE_LIMIT = 10000;
